import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "cover-uploader mt-2 relative rounded-lg border border-dashed border-gray-900/25" }
const _hoisted_2 = {
  key: 1,
  class: "flex justify-center items-center h-full"
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "flex justify-center text-sm/6 text-gray-600" }
const _hoisted_5 = {
  for: "cover-uploader-input",
  class: "relative cursor-pointer rounded-md bg-white font-semibold text-blue-700 focus-within:ring-2 focus-within:ring-blue-700 focus-within:ring-offset-2 focus-within:outline-hidden hover:text-blue-600"
}
const _hoisted_6 = {
  key: 0,
  class: "text-xs/5 text-gray-600"
}
const _hoisted_7 = {
  key: 1,
  class: "text-xs/5 text-gray-600"
}
const _hoisted_8 = {
  key: 0,
  class: "cover-loader absolute top-0 left-0 w-full h-full rounded-lg bg-black/60 text-white font-bold flex items-center justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhotoIcon = _resolveComponent("PhotoIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "cover-preview",
      class: "group relative w-full h-[250px] bg-cover bg-center rounded-lg",
      ref: "cover-preview",
      onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCoverPosition && _ctx.handleCoverPosition(...args))),
      style: _normalizeStyle({
                'background-image': `url('${_ctx.preview_url ?? (_ctx.cover_url ?? '')}')`,
                'background-position': `${_ctx.currentPosition.x}% ${_ctx.currentPosition.y}%`,
                'height': _ctx.height ? `${_ctx.height}px` : '250px',
            })
    }, [
      (!_ctx.is_file_uploading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "draggable",
            class: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[15px] h-[15px] bg-[#f1f3f9] border-[3px] border-[#f59c25] rounded-full cursor-move z-10",
            ref: "draggable",
            onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startDragging && _ctx.startDragging(...args))),
            onMouseup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.stopDragging && _ctx.stopDragging(...args))),
            style: _normalizeStyle({'display': _ctx.cover_url ? 'block' : 'none'})
          }, null, 36))
        : _createCommentVNode("", true),
      (!_ctx.cover_url && !_ctx.is_file_uploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_PhotoIcon, {
                class: "mx-auto size-12 text-gray-300",
                "aria-hidden": "true"
              }),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('cover_upload.upload_file')), 1)
                ])
              ]),
              (_ctx.allowVideo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('cover_upload.upload_tip')), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('cover_upload.upload_limits')), 1))
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.is_file_uploading && _ctx.cover_url)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "absolute bottom-0 left-0 w-full h-[30px] rounded-b-lg bg-gradient-to-b from-transparent to-black/65 text-white font-bold cursor-pointer flex items-center justify-center transition-opacity duration-300 lg:opacity-0 group-hover:opacity-100",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSelectCoverFile && _ctx.clickSelectCoverFile(...args)))
          }, [
            _createElementVNode("span", null, _toDisplayString((!_ctx.is_file_selected && !_ctx.cover_url) ? _ctx.$t('cover_upload.upload') : _ctx.$t('cover_upload.replace')), 1)
          ]))
        : _createCommentVNode("", true)
    ], 36),
    (_ctx.is_file_uploading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('cover_upload.uploading')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      type: "file",
      name: "cover",
      accept: "image/*,video/*",
      id: "cover-uploader-input",
      onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectCoverFile && _ctx.selectCoverFile(...args))),
      ref: "cover-uploader-input",
      class: "hidden"
    }, null, 544)
  ]))
}